import apiConfig from "src/utils/apiConfig";

export const LOGIN_DATA = 'auth/login';
export const VERIFY_OTP = 'auth/verifyotp'
export const LOGOUT = 'auth/logout';


export const loginRequest = (payload: { username: string; password: string }) => {
    const apiobject:any ={
        method: 'POST',
        authentication: true,
        endpoint: apiConfig.LOGIN,
        body: {
        username: payload.username,
        password: payload.password,
      },
    };
    return {
        type : LOGIN_DATA,
        payload: apiobject,
    }
}

export const verifyOtp = (payload: { username: string; otp: string }) => {
    const apiobject:any ={
        method: 'POST',
        authentication: true,
        endpoint: apiConfig.VERIFYOTP,
        body: {
        username: payload.username,
        otp: payload.otp,
      },
    };
    return {
        type : VERIFY_OTP,
        payload: apiobject,
    }
}

export const Logout = (payload: { username: any; roleid: any, employeeid:any }) => {
    const apiobject:any ={
        method: 'POST',
        authentication: true,
        endpoint: apiConfig.LOGOUT,
        body: {
        username: payload.username,
        roleid: payload.roleid,
        employeeid:payload.employeeid,
      },
    };
    return {
        type : LOGOUT,
        payload: apiobject,
    }
}